import React from "react";
import PropTypes from "prop-types";
import { CardContent } from "components";
import { Card } from "react-bootstrap";
import css from "./card-assessment.module.scss";
import { withLabelsContext } from "context";

function CardAssessment({
  name,
  hideTop,
  status,
  currName,
  date,
  endDate,
  currTitle,
  startDateoriginal,
  endDateOriginal,
  reassign,
  reassignDate,
  ...props
}) {
  return (
    <CardContent {...props}>
      {!hideTop && <CardContent.Top label={status == "Yet to Start" ? props.ctx_labels.singular.yetToStart.toUpperCase() :
        status == "Closed" ? props.ctx_labels.singular.closed.toUpperCase() :
          status == "Attended" ? props.ctx_labels.singular.attended.toUpperCase() :
            props.ctx_labels.singular.inProgress.toUpperCase()}
        title={currTitle} />
      }
      <Card.Body className="pb-2">
        {currTitle && <CardContent.Category>{currTitle}</CardContent.Category>}
        <Card.Title className="text-clamp-2">{name}</Card.Title>
      </Card.Body>
      {!props.hideDetails &&
      <Card.Footer className="pt-0">
        <div className={css.date}>
          <div>
            <div className="text-primary">{props.ctx_labels.singular.startDate}</div>
            <div>{date}</div>
          </div>
          <div>
            <div className="text-primary">{props.ctx_labels.singular.dueDate}</div>
          {reassign === 1 ? 
           <div>{reassignDate}</div> :
           <div>{endDate}</div> }
          </div>
        </div>
      </Card.Footer>
}
    </CardContent>
  );
}

CardAssessment.propTypes = {
  name: PropTypes.string,
  title: PropTypes.any,
  status: PropTypes.string,
  currName: PropTypes.string,
  date: PropTypes.string,
  endDate: PropTypes.string,
  hideTop: PropTypes.bool,
  currTitle: PropTypes.string,
  startDateoriginal: PropTypes.string,
  endDateOriginal: PropTypes.string,
};

export default withLabelsContext(CardAssessment);
